<script lang="ts">
	import { get } from "svelte/store";
	import { _ } from "svelte-i18n";
	import { Button, Spinner } from "@sveltestrap/sveltestrap";
	import { getSuggestions } from "../../actions/getSuggestions";
	import { suggestions } from "../../store/suggestions";
	import { pushToast } from "../../store/toasts";
	import SuggestionPickerModal from "./SuggestionPickerModal.svelte";

	let { onTopic }: { onTopic?: (topic: string) => void } = $props();

	let modalOpen = $state(false);
	let loadingSuggestions = $state(false);

	async function onClick() {
		loadingSuggestions = true;
		try {
			try {
				await getSuggestions();
			} catch {
				pushToast({
					variant: "danger",
					message: $_("landingpage.newPresentation.loadSuggestionsFailed"),
				});
				return;
			}
			if (get(suggestions).length === 0) {
				pushToast({
					variant: "warning",
					message: $_("landingpage.newPresentation.noSuggestions"),
				});
				return;
			}
			modalOpen = true;
		} finally {
			loadingSuggestions = false;
		}
	}

	function onSelect(topic: string) {
		onTopic?.(topic);
		modalOpen = false;
	}
</script>

<Button type="button" color="secondary" outline disabled={loadingSuggestions} on:click={onClick}>
	{#if loadingSuggestions}
		<Spinner size="sm" class="me-1" />
	{/if}
	{$_("landingpage.newPresentation.useSuggestion")}
</Button>

<SuggestionPickerModal bind:isOpen={modalOpen} suggestions={$suggestions} {onSelect} />
